import React from 'react';

const Loading = () => {
    return (
        <div className='text-center'>
            <button className="btn loading btn-warning">loading</button>
        </div>
    );
};

export default Loading;